
import { ISession } from '@interfaces/sesion.interface';
import { createAction, props } from '@ngrx/store';


enum UsersActionType {
  setUserSession = '[Users Component] Set User  user in store',
  getUserSession = '[Users Component] Get User  user in store ',


}


const setUserSession = createAction(
  UsersActionType.setUserSession,
  props<{ user: ISession }>()
);
const getUserSession = createAction(
  UsersActionType.getUserSession,
  props<{ user: ISession }>()
);

export const SessionActions = {
  setUserSession,
  getUserSession
}
